import React, { Fragment, useState, useEffect, useContext } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import DataTable, { createTheme } from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../contexts/ThemeContext";
import AddBrand from "../components/common/AddBrand";
import { getBrandData } from "../redux/actions/brandActions.js";
import { API_URL } from "../config/constant.js";

const BrandList = () => {
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [datas, setDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const { brandData, addbrandSuccess } = useSelector(state => state.brand);

  // Themes
  createTheme("darkMode", {
    text: { primary: "#FFFFFF" },
    background: { default: "#1E1E1E" }
  });

  createTheme("lightMode", {
    text: { primary: "#000000" },
    background: { default: "#FFFFFF" }
  });

  const handleEdit = (row) => {
    debugger
    setEditData(row);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setEditData(null);
  };

  const columns = [
    {
      name: <b>S.No</b>,
      cell: (row, index) =>
        index + 1 + (currentPage - 1) * itemsPerPage
    },
    {
      name: <b>Brand Name</b>,
      selector: row => row?.brandName
    },
    {
      name: <b>Logo</b>,
      cell: row => (
        <img
          src={`${API_URL}${row?.logoUrl}`}
          alt="Logo"
          style={{ maxWidth: "100px", maxHeight: "50px", objectFit: "contain" }}
        />
      )
    },
    {
      name: <b>Status</b>,
      selector: row => row?.status || "active",
      cell: row => (
        <span
          className={`badge ${
            row?.status === "inactive" ? "bg-danger" : "bg-success"
          }`}
        >
          {row?.status || "active"}
        </span>
      )
    },
    {
      name: <b>Actions</b>,
      cell: row => (
        <span onClick={() => handleEdit(row)}>
          <i
            className="fa fa-pencil p-2"
            style={{
              color: "rgb(40, 167, 69)",
              cursor: "pointer",
              fontSize: 20
            }}
          ></i>
        </span>
      )
    }
  ];

  // Fetch brands
  useEffect(() => {
    dispatch(getBrandData(currentPage, itemsPerPage));
  }, [currentPage, dispatch, itemsPerPage]);

  useEffect(() => {
    if (addbrandSuccess && brandData?.data) {
      setDatas(brandData.data);
      setTotalPages(brandData.pagination?.totalPages || 1);
      setItemsPerPage(brandData.pagination?.itemsPerPage || 10);
    }
  }, [addbrandSuccess, brandData]);

  return (
    <Fragment>
      <div className="flex flex-row justify-between">
        <h4 className="mt-4 mb-10">Brand</h4>
        <div className="flex items-center gap-2">
          <Button type="button" className="text-white fw-bold py-2 rounded-4xl" onClick={() => setOpen(true)}>Create Brand</Button>
        </div>
      </div>

      <Container fluid="true">
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <DataTable
                  pagination
                  columns={columns}
                  data={datas}
                  theme={theme === "dark" ? "darkMode" : "lightMode"}
                  paginationServer
                  paginationTotalRows={totalPages * itemsPerPage}
                  paginationPerPage={itemsPerPage}
                  onChangePage={setCurrentPage}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <AddBrand
        openModal={open}
        onCloseModal={closeModal}
        brandData={editData}
      />
    </Fragment>
  );
};

export default BrandList;
